import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import LABEL from '../../../business-const/Label/Label'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import {
    TablePaginationPadrao,
    rowPertentePage,
    setPageInclusao,
    setPageExclusao,
} from '../../../business-components/Pagination/Pagination'

import {
    TextValidatorText,
    TextValidatorNumberRequired,
    TextValidatorValor,
    TextValidatorValorRequired,
    TextValidatorTextMultiline,
    TextValidatorMesAnoRequired,
} from '../../../business-components/TextValidator/TextValidator'

import {
    TextFieldTextSelectRequired,
    TextFieldNumberSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    CheckboxPadrao
} from '../../../business-components/Checkbox/Checkbox'

import {
    tituloCliente,
    tituloConjuge,
} from '../cliente-form/ClienteService'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import tipoCalculoAcumuladoList from '../../../business-rules/List/tipoCalculoAcumuladoList'

import tipoReceitaMensalEntradaDadosList from '../../../business-rules/List/tipoReceitaMensalEntradaDadosList'

import tipoPeriodicidadeList from '../../../business-rules/List/tipoPeriodicidadeList'

import tipoMultiploSalarioSeguroVidaEmGrupo from '../../../business-rules/List/tipoMultiploSalarioSeguroVidaEmGrupo'

import seguradoraList from '../../../business-rules/List/SeguroVida/seguradoraList'

import {
    IconButtonClearEntradaDados,
    IconButtonHelp,
} from '../../../business-components/IconButton/IconButton'

import {
    atualizaPerguntaValorOuValor2,
} from '../form-form/FormServicePerguntas'

import {
    processaAlteracaoReceitaMensalTipoReceitaMensal,
    processaAlteracaoReceitaMensalValorInssPensaoInvalidez,
    processaAlteracaoReceitaMensalAlterarValorInssPensaoMorteAposentadoria,
    processaAlteracaoReceitaMensalAlterarTipoCalculoAcumulado,
    processaAlteracaoReceitaMensalTemSeguroVidaEmGrupo,
    processaAlteracaoReceitaMensalTipoMultiploSalarioSeguroVidaEmGrupo,
    processaAlteracaoReceitaMensalExtensivelClienteConjuge,
    processaAlteracaoReceitaMensalExtensivelFilhao,
    processaAlteracaoReceitaMensalSeguradora,
} from './GarantiasServiceReceitaMensal'



export const TablePaginationPadraoReceitaMensal = ({ values, setFieldValue }) => {

    return (
        <TablePaginationPadrao
            setFieldValue={setFieldValue}
            list={values.receitaMensalPagination}
            nameRowsPerPage={'rowsPerPageReceitaMensal'}
            namePage={'pageReceitaMensal'}
            rowsPerPage={values.rowsPerPageReceitaMensal}
            page={values.pageReceitaMensal}
        />
    )
}

export const rowPertentePageReceitaMensal = (values, indAux) => {
    
    return rowPertentePage(indAux, values.pageReceitaMensal, values.rowsPerPageReceitaMensal)
}

export const setPageInclusaoReceitaMensal = (values, setFieldValue) => {

    return setPageInclusao(setFieldValue, 'pageReceitaMensal', values.receitaMensalPagination, values.rowsPerPageReceitaMensal)
}



export const Familiar = ({ values, item, ind, handleChange, expandiu }) => {

    return (
        <TextFieldNumberSelect
            name={`receitaMensal[${ind}].familiar`}
            label={LABEL.familiar}
            value={item.familiar || ''}
            onChange={handleChange}
            list={values.totalReceitaMensal}
            disabled={item.planejamentoEspecializacaoPeriodoSabatico || expandiu}
        />
    )
}

export const TipoReceitaMensal = ({ TextFieldNumberSelectTipoReceitaMensal, values, item, ind, handleChange, expandiu }) => {

    return (
        <TextFieldNumberSelectTipoReceitaMensal
            name={`receitaMensal[${ind}].tipoReceitaMensal`}
            placeholder={LABEL.tipoReceitaMensal}
            value={item.tipoReceitaMensal || ''}
            onChange={handleChange}
            list={tipoReceitaMensalEntradaDadosList(item.tipoReceitaMensal)}
            onBlur={processaAlteracaoReceitaMensalTipoReceitaMensal(item, values)}
            disabled={/*item.idPatrimonioImobilizado > 0 || */item.planejamentoEspecializacaoPeriodoSabatico || expandiu}
        />
    )
}

export const IconButtonClearEntradaDadosReceitaMensal = ({ values, setFieldValue, item, ind, arrayHelpers, simplificado }) => {

    return (
        /*!item.idPatrimonioImobilizado && */!item.idPergunta && !simplificado && !item.planejamentoEspecializacaoPeriodoSabatico
            ?
                <IconButtonClearEntradaDados
                    onClick={() => {
                        arrayHelpers.remove(ind)
                        setPageExclusao(setFieldValue, 'pageReceitaMensal', values.receitaMensalPagination,
                            values.rowsPerPageReceitaMensal, values.pageReceitaMensal)
                    }}
                />
            :
                ''
    )
}

export const ValorBruto = ({ item, ind, handleChange, expandiu }) => {

    return (
        <TextValidatorValorRequired
            name={`receitaMensal[${ind}].valorBruto`}
            label={LABEL.receitaBruta}
            value={item.valorBruto || ''}
            onChange={handleChange}
            disabled={expandiu}
        />
    )
}

export const Valor = ({ values, item, ind, handleChange/*, tipoReceitaMensalSelecionada*/, expandiu }) => {

    return (
        <TextValidatorValorRequired
            name={`receitaMensal[${ind}].valor`}
            label={LABEL.receitaLiquida}
            value={item.valor || ''}
            onChange={handleChange}
            onBlur={
                atualizaPerguntaValorOuValor2(values, item.idPergunta,
                    item.valor, item.familiar)
            }
            disabled={/*item.idPatrimonioImobilizado > 0 || */item.planejamentoEspecializacaoPeriodoSabatico || expandiu}
        />
    )
}

export const TipoPeriodicidadeRecebto = ({ item, ind, handleChange, expandiu }) => {

    return (
        <TextFieldTextSelectRequired
            name={`receitaMensal[${ind}].tipoPeriodicidadeRecebto`}
            label={LABEL.tipoPeriodicidadeRecebto}
            value={item.tipoPeriodicidadeRecebto || ''}
            onChange={handleChange}
            list={tipoPeriodicidadeList(false, true, true)}
            disabled={/*item.idPatrimonioImobilizado > 0 || */item.idPergunta > 0 || item.planejamentoEspecializacaoPeriodoSabatico || expandiu}
        />
    )
}

export const ValorInssPensaoInvalidez = ({ item, ind, handleChange, tipoReceitaMensalSelecionada, simplificado }) => {

    return (
        <TextValidatorValor
            name={`receitaMensal[${ind}].valorInssPensaoInvalidez`}
            label={
                tipoReceitaMensalSelecionada.informaInssPensao === "I" 
                    ?
                        simplificado &&
                        item.valorInssPensaoInvalidez === item.valorInssPensaoMorte &&
                        item.valorInssPensaoInvalidez === item.valorInssPensaoAposentadoria
                            ?
                                LABEL.valorInssRendaPrevista
                            :
                                LABEL.valorInssInvalidez 
                    :
                        simplificado  &&
                        item.valorInssPensaoInvalidez === item.valorInssPensaoMorte &&
                        item.valorInssPensaoInvalidez === item.valorInssPensaoAposentadoria
                            ?
                                LABEL.valorPensaoRendaPrevista
                            :
                                LABEL.valorPensaoInvalidez
            }
            value={item.valorInssPensaoInvalidez || ''}
            onChange={handleChange}
            onBlur={
                processaAlteracaoReceitaMensalValorInssPensaoInvalidez(item)
            }
        />
    )
}

export const ValorInssPensaoMorte = ({ item, ind, handleChange, tipoReceitaMensalSelecionada }) => {

    return (
        <TextValidatorValor
            name={`receitaMensal[${ind}].valorInssPensaoMorte`}
            label={tipoReceitaMensalSelecionada.informaInssPensao === "I" 
                ? LABEL.valorInssMorte
                : LABEL.valorPensaoMorte}
            value={item.valorInssPensaoMorte || ''}
            onChange={handleChange}
            disabled={!item.alterarValorInssPensaoMorteAposentadoria}
        />
    )
}

export const ValorInssPensaoAposentadoria = ({ item, ind, handleChange, tipoReceitaMensalSelecionada }) => {

    return (
        <TextValidatorValor
            name={`receitaMensal[${ind}].valorInssPensaoAposentadoria`}
            label={tipoReceitaMensalSelecionada.informaInssPensao === "I" 
                ? LABEL.valorInssAposentadoria
                : LABEL.valorPensaoAposentadoria}
            value={item.valorInssPensaoAposentadoria || ''}
            onChange={handleChange}
            disabled={!item.alterarValorInssPensaoMorteAposentadoria}
        />
    )
}

export const AlterarValorInssPensaoMorteAposentadoria = ({ item, ind, handleChange, tipoReceitaMensalSelecionada }) => {

    return (
        <CheckboxPadrao
            name={`receitaMensal[${ind}].alterarValorInssPensaoMorteAposentadoria`}
            label={tipoReceitaMensalSelecionada.informaInssPensao === "I" 
                ? LABEL.alterarValorInssMorteAposentadoria
                : LABEL.alterarValorPensaoMorteAposentadoria}
            checked={item.alterarValorInssPensaoMorteAposentadoria}
            onChange={handleChange}
            onBlur={processaAlteracaoReceitaMensalAlterarValorInssPensaoMorteAposentadoria(item)}
        />
    )
}

export const HelpInssInvalidezMorteAposentadoria = () => {

    return (
        <IconButtonHelp
            align="right"
            helpTitle={LABEL.inssInvalidezMorteAposentadoria}
            helpText={HELPTEXT.inssInvalidezMorteAposentadoria}
        />
    )
}

export const PeriodoReceitaMensal = ({ tipoReceitaMensalSelecionada }) => {

    return (
        <>
            <span
                className='text-muted'
            >
                {LABEL.periodoReceitaMensal + ": "}
            </span>
            <span>
                {pesquisaList(tipoCalculoAcumuladoList,
                    tipoReceitaMensalSelecionada.tipoCalculoAcumulado)
                        .descricao
                }
            </span>
        </>
    )
}

export const AlterarTipoCalculoAcumulado = ({ values, item, ind, handleChange, tipoReceitaMensalSelecionada }) => {

    return (
        <CheckboxPadrao
            name={`receitaMensal[${ind}].alterarTipoCalculoAcumulado`}
            label={LABEL.alterarTipoCalculoAcumulado}
            checked={item.alterarTipoCalculoAcumulado}
            onChange={handleChange}
            onBlur={
                processaAlteracaoReceitaMensalAlterarTipoCalculoAcumulado
                    (item, values, tipoReceitaMensalSelecionada)
            }
            disabled={/*item.idPatrimonioImobilizado || */item.planejamentoEspecializacaoPeriodoSabatico}
        />
    )
}

export const MesAnoInicial = ({ item, ind, handleChange, expandiu }) => {

    return (
        <TextValidatorMesAnoRequired
            name={`receitaMensal[${ind}].mesAnoInicial`}
            label={LABEL.mesAnoInicial}
            value={item.mesAnoInicial || ''}
            onChange={handleChange}
            disabled={item.planejamentoEspecializacaoPeriodoSabatico || expandiu}
        />
    )
}

export const MesAnoFinal = ({ item, ind, handleChange, expandiu }) => {

    return (
        <TextValidatorMesAnoRequired
            name={`receitaMensal[${ind}].mesAnoFinal`}
            label={LABEL.mesAnoFinal}
            value={item.mesAnoFinal || ''}
            onChange={handleChange}
            disabled={item.planejamentoEspecializacaoPeriodoSabatico || expandiu}
        />
    )
}

export const ReceitaMensalAteAposentadoria = ({ item, ind, handleChange }) => {

    return (
        <CheckboxPadrao
            name={`receitaMensal[${ind}].receitaMensalAteAposentadoria`}
            label={LABEL.receitaMensalAteAposentadoria}
            checked={item.receitaMensalAteAposentadoria}
            onChange={handleChange}
        />
    )
}

export const NaoConsiderarGarantiaMorteCliente = ({ values, item, ind, handleChange }) => {

    return (
        <CheckboxPadrao
            name={`receitaMensal[${ind}].naoConsiderarGarantiaMorteCliente`}
            label={LABEL.naoConsiderarGarantiaMorte + ' ' + tituloCliente(values)}
            checked={item.naoConsiderarGarantiaMorteCliente}
            onChange={handleChange}
        />
    )
}

export const NaoConsiderarGarantiaMorteConjuge = ({ values, item, ind, handleChange }) => {

    return (
        <CheckboxPadrao
            name={`receitaMensal[${ind}].naoConsiderarGarantiaMorteConjuge`}
            label={LABEL.naoConsiderarGarantiaMorte + ' ' + tituloConjuge(values)}
            checked={item.naoConsiderarGarantiaMorteConjuge}
            onChange={handleChange}
        />
    )
}

export const NaoConsiderarGarantiaInvalidezCliente = ({ values, item, ind, handleChange }) => {

    return (
        <CheckboxPadrao
            name={`receitaMensal[${ind}].naoConsiderarGarantiaInvalidezCliente`}
            label={LABEL.naoConsiderarGarantiaInvalidez + ' ' + tituloCliente(values)}
            checked={item.naoConsiderarGarantiaInvalidezCliente}
            onChange={handleChange}
        />
    )
}

export const NaoConsiderarGarantiaInvalidezConjuge = ({ values, item, ind, handleChange }) => {

    return (
        <CheckboxPadrao
            name={`receitaMensal[${ind}].naoConsiderarGarantiaInvalidezConjuge`}
            label={LABEL.naoConsiderarGarantiaInvalidez + ' ' + tituloConjuge(values)}
            checked={item.naoConsiderarGarantiaInvalidezConjuge}
            onChange={handleChange}
        />
    )
}

export const HelpNaoConsiderarGarantiaMorteInvalidez = () => {

    return (
        <IconButtonHelp
            helpTitle={LABEL.naoConsiderarGarantiaMorteInvalidez}
            helpText={HELPTEXT.naoConsiderarGarantiaMorteInvalidezReceitaMensal}
        />
    )
}

export const TemSeguroVidaEmGrupo = ({ values, item, ind, handleChange }) => {

    return (
        <CheckboxPadrao
            name={`receitaMensal[${ind}].temSeguroVidaEmGrupo`}
            label={LABEL.temSeguroVidaEmGrupo}
            checked={item.temSeguroVidaEmGrupo}
            onChange={handleChange}
            onBlur={processaAlteracaoReceitaMensalTemSeguroVidaEmGrupo(item, values)}
        />
    )
}

export const TipoMultiploSalarioSeguroVidaEmGrupo = ({ item, ind, handleChange }) => {

    return (
        <TextFieldTextSelectRequired
            name={`receitaMensal[${ind}].tipoMultiploSalarioSeguroVidaEmGrupo`}
            label={LABEL.tipoMultiploSalarioSeguroVidaEmGrupo}
            value={item.tipoMultiploSalarioSeguroVidaEmGrupo || ''}
            onChange={handleChange}
            list={tipoMultiploSalarioSeguroVidaEmGrupo}
            onBlur={processaAlteracaoReceitaMensalTipoMultiploSalarioSeguroVidaEmGrupo(item)}
        />
    )
}

export const ValorCSSeguroVidaEmGrupoMorte = ({ item, ind, handleChange, tipoMultiploSalarioSeguroVidaEmGrupoSelecionado }) => {

    return (
        <TextValidatorValor
            name={`receitaMensal[${ind}].valorCSSeguroVidaEmGrupoMorte`}
            label={LABEL.valorCSSeguroVidaEmGrupoMorte}
            value={item.valorCSSeguroVidaEmGrupoMorte || ''}
            onChange={handleChange}
            disabled={tipoMultiploSalarioSeguroVidaEmGrupoSelecionado
                .multiploSalarioBruto > 0}
        />
    )
}

export const ValorCSSeguroVidaEmGrupoMorteAcidental = ({ item, ind, handleChange, tipoMultiploSalarioSeguroVidaEmGrupoSelecionado }) => {

    return (
        <TextValidatorValor
            name={`receitaMensal[${ind}].valorCSSeguroVidaEmGrupoMorteAcidental`}
            label={LABEL.valorCSSeguroVidaEmGrupoMorteAcidental}
            value={item.valorCSSeguroVidaEmGrupoMorteAcidental || ''
            }
            onChange={handleChange}
            disabled={tipoMultiploSalarioSeguroVidaEmGrupoSelecionado
                .multiploSalarioBruto > 0}
        />
    )
}

export const ValorCSSeguroVidaEmGrupoInvalidezPorAcidente = ({ item, ind, handleChange, tipoMultiploSalarioSeguroVidaEmGrupoSelecionado }) => {

    return (
        <TextValidatorValor
            name={`receitaMensal[${ind}].valorCSSeguroVidaEmGrupoInvalidezPorAcidente`}
            label={LABEL.valorCSSeguroVidaEmGrupoInvalidezPorAcidente}
            value={item.valorCSSeguroVidaEmGrupoInvalidezPorAcidente || ''}
            onChange={handleChange}
            disabled={tipoMultiploSalarioSeguroVidaEmGrupoSelecionado
                .multiploSalarioBruto > 0}
        />
    )
}

export const ValorCSSeguroVidaEmGrupoInvalidezFuncionalPorDoenca = ({ item, ind, handleChange, tipoMultiploSalarioSeguroVidaEmGrupoSelecionado }) => {

    return (
        <TextValidatorValor
            name={`receitaMensal[${ind}].valorCSSeguroVidaEmGrupoInvalidezFuncionalPorDoenca`}
            label={LABEL.valorCSSeguroVidaEmGrupoInvalidezFuncionalPorDoenca}
            value={item.valorCSSeguroVidaEmGrupoInvalidezFuncionalPorDoenca || ''}
            onChange={handleChange}
            disabled={tipoMultiploSalarioSeguroVidaEmGrupoSelecionado
                .multiploSalarioBruto > 0}
        />
    )
}


export const ValorCSSeguroVidaEmGrupoDoencasGraves = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorValor
            name={`receitaMensal[${ind}].valorCSSeguroVidaEmGrupoDoencasGraves`}
            label={LABEL.valorCSSeguroVidaEmGrupoDoencasGraves}
            value={item.valorCSSeguroVidaEmGrupoDoencasGraves || ''}
            onChange={handleChange}
        />
    )
}

export const ValorCSSeguroVidaEmGrupoFuneral = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorValor
            name={`receitaMensal[${ind}].valorCSSeguroVidaEmGrupoFuneral`}
            label={LABEL.valorCSSeguroVidaEmGrupoFuneral}
            value={item.valorCSSeguroVidaEmGrupoFuneral || ''}
            onChange={handleChange}
        />
    )
}

export const ExtensivelClienteConjuge = ({ values, item, ind, handleChange }) => {

    return (
        <CheckboxPadrao
            name={`receitaMensal[${ind}].extensivelClienteConjuge`}
            label={
                LABEL.extensivelClienteConjuge + " " + 
                (
                    item.familiar === HARDCODE.idFamiliarCliente
                        ?
                            tituloConjuge(values)
                        :
                            tituloCliente(values)
                )
            }
            checked={item.extensivelClienteConjuge}
            onChange={handleChange}
            onBlur={processaAlteracaoReceitaMensalExtensivelClienteConjuge(item)}
        />
    )
}

export const PercExtensivelClienteConjuge = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorNumberRequired
            name={`receitaMensal[${ind}].percExtensivelClienteConjuge`}
            label={LABEL.perc}
            value={item.percExtensivelClienteConjuge || ''}
            onChange={handleChange}
            numMin={NUMMIN.perc}
            numMax={NUMMAX.perc}
        />
    )
}

export const ExtensivelFilhao = ({ item, ind, handleChange }) => {

    return (
        <CheckboxPadrao
            name={`receitaMensal[${ind}].extensivelFilhao`}
            label={LABEL.extensivelFilhao}
            checked={item.extensivelFilhao}
            onChange={handleChange}
            onBlur={processaAlteracaoReceitaMensalExtensivelFilhao(item)}
        />
    )
}

export const PercExtensivelFilhao = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorNumberRequired
            name={`receitaMensal[${ind}].percExtensivelFilhao`}
            label={LABEL.perc}
            value={item.percExtensivelFilhao || ''}
            onChange={handleChange}
            numMin={NUMMIN.perc}
            numMax={NUMMAX.perc}
        />
    )
}

export const Seguradora = ({ item, ind, handleChange }) => {

    return (
        <TextFieldNumberSelect
            name={`receitaMensal[${ind}].seguradora`}
            label={LABEL.seguradora}
            value={item.seguradora || ''}
            onChange={handleChange}
            list={seguradoraList()}
            onBlur={processaAlteracaoReceitaMensalSeguradora(item)}
        />
    )
}

export const SeguradoraOutras = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorText
            name={`receitaMensal[${ind}].seguradoraOutras`}
            label={LABEL.seguradoraOutras}
            value={item.seguradoraOutras || ''}
            onChange={handleChange}
            tamMax={TAMMAX.seguradoraOutras}
        />
    )
}

export const DescricaoOutras = ({ item, ind, handleChange, expandiu }) => {

    return (
        <TextValidatorText
            name={`receitaMensal[${ind}].descricaoOutras`}
            label={LABEL.descricao}
            value={item.descricaoOutras || ''}
            onChange={handleChange}
            tamMax={TAMMAX.descricaoReceitaMensalOutras}
            notToUpperCase={true}
            disabled={expandiu}
        />
    )
}

export const HelpDescricaoOutras = () => {
    
    return (
        <IconButtonHelp
            helpTitle={LABEL.descricao}
            helpText={HELPTEXT.descricaoReceitaMensalOutras}
        />
    )
}

export const Observacao = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorTextMultiline
            name={`receitaMensal[${ind}].observacao`}
            label={LABEL.observacao}
            value={item.observacao || ''}
            onChange={handleChange}
            tamMax={TAMMAX.observacao}
            disabled={/*item.idPatrimonioImobilizado > 0 || */item.idPergunta > 0}
        />
    )
}